import { Wallet } from 'interfaces';
import { ConvertBoxDataType } from '../convertBox.index';
import { _CoinsProps } from './coinsList/coinsList.interface';

export interface __ConvertBoxRef {
    setCoin: (coin: _CoinsProps) => void;
}
export enum __TypeOfOrderEnum {
    buy = 1,
    sell,
    swap,
}

export interface __InitialConvertBoxProps {
    onSubmit: (e: ConvertBoxDataType) => void;
    isPreview?: boolean;
    title?: string;
    wallet?: Wallet
}
